import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  nl: {
    // Navigation
    nav_home: 'Home',
    nav_bulk: 'Bulk Check',
    nav_bank: 'Bank Upload',
    nav_uitleg: 'Uitleg',
    nav_pricing: 'Prijzen',
    nav_login: 'Inloggen',
    nav_register: 'Registreren',
    nav_dashboard: 'Dashboard',
    nav_logout: 'Uitloggen',
    
    // Hero
    hero_title: 'Controleer Belastingdienst Betalingskenmerk',
    hero_subtitle: 'Check direct welk belastingtype, tijdvak en jaar bij een 16-cijferig betalingskenmerk hoort.',
    hero_placeholder: '1234 5678 9012 3456',
    hero_button: 'Controleer',
    hero_example: 'Voorbeeld: 1865553996601020',
    
    // Results
    result_valid: 'Geldig betalingskenmerk',
    result_invalid: 'Ongeldig betalingskenmerk',
    result_tax_type: 'Belastingtype',
    result_year: 'Jaar',
    result_period: 'Tijdvak',
    result_assessment: 'Aanslagnummer',
    result_id: 'Identificatie',
    result_copy: 'Kopiëren',
    result_copied: 'Gekopieerd!',
    
    // Bulk
    bulk_title: 'Bulk Check',
    bulk_subtitle: 'Controleer meerdere betalingskenmerken tegelijk',
    bulk_placeholder: 'Plak betalingskenmerken hier (één per regel)',
    bulk_button: 'Alles Controleren',
    bulk_export_csv: 'Export CSV',
    bulk_export_excel: 'Export Excel',
    bulk_results: 'resultaten',
    bulk_valid: 'geldig',
    bulk_invalid: 'ongeldig',
    
    // Bank
    bank_title: 'Bank Upload',
    bank_subtitle: 'Upload een bankafschrift CSV en vind automatisch alle betalingskenmerken',
    bank_upload: 'Sleep CSV hier of klik om te uploaden',
    bank_supported: 'Ondersteunt ING, Rabobank, ABN AMRO en andere banken',
    bank_scanning: 'Bezig met scannen...',
    bank_found: 'betalingskenmerken gevonden',
    
    // Uitleg
    uitleg_title: 'Wat is een betalingskenmerk?',
    uitleg_intro: 'Een betalingskenmerk is een 16-cijferig nummer dat de Belastingdienst gebruikt om betalingen te identificeren. Het bevat gecodeerde informatie over het type belasting, het tijdvak en de belastingplichtige.',
    uitleg_structure_title: 'Opbouw van het kenmerk',
    uitleg_structure_1: 'Cijfers 1-2: Belastingtype (bijv. 01 = BTW)',
    uitleg_structure_2: 'Cijfers 3-4: Jaar (laatste 2 cijfers)',
    uitleg_structure_3: 'Cijfer 5: Tijdvaktype (M=maand, K=kwartaal, J=jaar)',
    uitleg_structure_4: 'Cijfers 6-7: Tijdvaknummer',
    uitleg_structure_5: 'Cijfers 8-14: Identificatienummer',
    uitleg_structure_6: 'Cijfers 15-16: Controlecijfers',
    uitleg_validation_title: 'Mod-11 Validatie',
    uitleg_validation_text: 'Het betalingskenmerk bevat een controlecijfer op basis van het mod-11 algoritme. Dit zorgt ervoor dat typefouten worden gedetecteerd.',
    uitleg_who_title: 'Voor wie is deze tool?',
    uitleg_who_1: 'Boekhouders en accountants',
    uitleg_who_2: 'Administratiekantoren',
    uitleg_who_3: 'Ondernemers en ZZP\'ers',
    uitleg_who_4: 'Financiële afdelingen',
    
    // Pricing
    pricing_title: 'Kies uw plan',
    pricing_subtitle: 'Gratis beginnen of upgrade voor meer mogelijkheden',
    pricing_free: 'Gratis',
    pricing_free_price: '€0',
    pricing_free_feature_1: '1 kenmerk per keer',
    pricing_free_feature_2: 'Basisresultaten',
    pricing_free_feature_3: 'Geen registratie nodig',
    pricing_pro: 'Pro',
    pricing_pro_price: '€15',
    pricing_pro_month: '/maand',
    pricing_pro_feature_1: 'Onbeperkt bulk decoderen',
    pricing_pro_feature_2: 'Bank CSV upload',
    pricing_pro_feature_3: 'Excel/CSV export',
    pricing_pro_feature_4: 'API toegang',
    pricing_pro_feature_5: 'Automatische tekstscan',
    pricing_team: 'Team',
    pricing_team_price: '€79',
    pricing_team_month: '/maand',
    pricing_team_feature_1: 'Alles van Pro',
    pricing_team_feature_2: 'Meerdere gebruikers',
    pricing_team_feature_3: 'Prioriteit ondersteuning',
    pricing_team_feature_4: 'Onbeperkte API calls',
    pricing_cta: 'Start nu',
    pricing_current: 'Huidige plan',
    
    // Auth
    auth_login_title: 'Inloggen',
    auth_register_title: 'Account aanmaken',
    auth_email: 'E-mail',
    auth_password: 'Wachtwoord',
    auth_name: 'Naam',
    auth_company: 'Bedrijf (optioneel)',
    auth_login_btn: 'Inloggen',
    auth_register_btn: 'Registreren',
    auth_no_account: 'Nog geen account?',
    auth_has_account: 'Al een account?',
    auth_error_email: 'Vul een geldig e-mailadres in',
    auth_error_password: 'Wachtwoord moet minimaal 6 tekens zijn',
    auth_forgot_password: 'Wachtwoord vergeten?',
    
    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Welkom terug',
    dashboard_plan: 'Uw plan',
    dashboard_decoded: 'Kenmerken gecheckt',
    dashboard_quick_decode: 'Snel checken',
    
    // Common
    common_loading: 'Laden...',
    common_error: 'Er is een fout opgetreden',
    common_pro_required: 'Pro plan vereist',
    common_upgrade: 'Upgrade naar Pro',
    
    // Footer
    footer_disclaimer: 'Deze tool is niet verbonden aan de Belastingdienst. Gebruik op eigen risico.',
    footer_privacy: 'Privacy',
    footer_terms: 'Voorwaarden',
    footer_contact: 'Contact',
  },
  en: {
    // Navigation
    nav_home: 'Home',
    nav_bulk: 'Bulk Check',
    nav_bank: 'Bank Upload',
    nav_uitleg: 'Guide',
    nav_pricing: 'Pricing',
    nav_login: 'Login',
    nav_register: 'Register',
    nav_dashboard: 'Dashboard',
    nav_logout: 'Logout',
    
    // Hero
    hero_title: 'Check Dutch Tax Payment Reference',
    hero_subtitle: 'Check 16-digit payment references instantly. Discover which tax type, period and year a payment belongs to.',
    hero_placeholder: '1234 5678 9012 3456',
    hero_button: 'Check',
    hero_example: 'Example: 1865553996601020',
    
    // Results
    result_valid: 'Valid payment reference',
    result_invalid: 'Invalid payment reference',
    result_tax_type: 'Tax type',
    result_year: 'Year',
    result_period: 'Period',
    result_assessment: 'Assessment number',
    result_id: 'Identification',
    result_copy: 'Copy',
    result_copied: 'Copied!',
    
    // Bulk
    bulk_title: 'Bulk Check',
    bulk_subtitle: 'Check multiple payment references at once',
    bulk_placeholder: 'Paste payment references here (one per line)',
    bulk_button: 'Check All',
    bulk_export_csv: 'Export CSV',
    bulk_export_excel: 'Export Excel',
    bulk_results: 'results',
    bulk_valid: 'valid',
    bulk_invalid: 'invalid',
    
    // Bank
    bank_title: 'Bank Upload',
    bank_subtitle: 'Upload a bank statement CSV and automatically find all payment references',
    bank_upload: 'Drag CSV here or click to upload',
    bank_supported: 'Supports ING, Rabobank, ABN AMRO and other banks',
    bank_scanning: 'Scanning...',
    bank_found: 'payment references found',
    
    // Uitleg
    uitleg_title: 'What is a payment reference?',
    uitleg_intro: 'A payment reference (betalingskenmerk) is a 16-digit number used by the Dutch Tax Authority to identify payments. It contains encoded information about the tax type, period and taxpayer.',
    uitleg_structure_title: 'Structure of the reference',
    uitleg_structure_1: 'Digits 1-2: Tax type (e.g. 01 = VAT)',
    uitleg_structure_2: 'Digits 3-4: Year (last 2 digits)',
    uitleg_structure_3: 'Digit 5: Period type (M=month, K=quarter, J=year)',
    uitleg_structure_4: 'Digits 6-7: Period number',
    uitleg_structure_5: 'Digits 8-14: Identification number',
    uitleg_structure_6: 'Digits 15-16: Check digits',
    uitleg_validation_title: 'Mod-11 Validation',
    uitleg_validation_text: 'The payment reference contains a check digit based on the mod-11 algorithm. This ensures that typing errors are detected.',
    uitleg_who_title: 'Who is this tool for?',
    uitleg_who_1: 'Bookkeepers and accountants',
    uitleg_who_2: 'Administration offices',
    uitleg_who_3: 'Entrepreneurs and freelancers',
    uitleg_who_4: 'Financial departments',
    
    // Pricing
    pricing_title: 'Choose your plan',
    pricing_subtitle: 'Start for free or upgrade for more features',
    pricing_free: 'Free',
    pricing_free_price: '€0',
    pricing_free_feature_1: '1 reference at a time',
    pricing_free_feature_2: 'Basic results',
    pricing_free_feature_3: 'No registration required',
    pricing_pro: 'Pro',
    pricing_pro_price: '€15',
    pricing_pro_month: '/month',
    pricing_pro_feature_1: 'Unlimited bulk decoding',
    pricing_pro_feature_2: 'Bank CSV upload',
    pricing_pro_feature_3: 'Excel/CSV export',
    pricing_pro_feature_4: 'API access',
    pricing_pro_feature_5: 'Automatic text scan',
    pricing_team: 'Team',
    pricing_team_price: '€79',
    pricing_team_month: '/month',
    pricing_team_feature_1: 'Everything in Pro',
    pricing_team_feature_2: 'Multiple users',
    pricing_team_feature_3: 'Priority support',
    pricing_team_feature_4: 'Unlimited API calls',
    pricing_cta: 'Get started',
    pricing_current: 'Current plan',
    
    // Auth
    auth_login_title: 'Login',
    auth_register_title: 'Create account',
    auth_email: 'Email',
    auth_password: 'Password',
    auth_name: 'Name',
    auth_company: 'Company (optional)',
    auth_login_btn: 'Login',
    auth_register_btn: 'Register',
    auth_no_account: 'No account yet?',
    auth_has_account: 'Already have an account?',
    auth_error_email: 'Enter a valid email address',
    auth_error_password: 'Password must be at least 6 characters',
    auth_forgot_password: 'Forgot password?',
    
    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_welcome: 'Welcome back',
    dashboard_plan: 'Your plan',
    dashboard_decoded: 'References checked',
    dashboard_quick_decode: 'Quick check',
    
    // Common
    common_loading: 'Loading...',
    common_error: 'An error occurred',
    common_pro_required: 'Pro plan required',
    common_upgrade: 'Upgrade to Pro',
    
    // Footer
    footer_disclaimer: 'This tool is not affiliated with the Dutch Tax Authority. Use at your own risk.',
    footer_privacy: 'Privacy',
    footer_terms: 'Terms',
    footer_contact: 'Contact',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'nl';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'nl' ? 'en' : 'nl');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
